import { Package } from 'lucide-react'

interface ProductPreviewProps {
  product: any
}

export function ProductPreview({ product }: ProductPreviewProps) {
  if (!product) {
    return (
      <div className="flex flex-col items-center justify-center h-full text-center">
        <Package className="h-16 w-16 text-muted-foreground mb-4" />
        <p className="text-muted-foreground">Product preview will appear here</p>
      </div>
    )
  }

  return (
    <div className="bg-white rounded-lg p-4 shadow-sm">
      {/* Images */}
      {product.images?.[0] ? (
        <div className="mb-3">
          <img
            src={product.images[0]}
            alt={product.name}
            className="w-full h-48 object-cover rounded-lg"
          />
          {product.images.length > 1 && (
            <div className="flex gap-2 mt-2">
              {product.images.slice(1, 4).map((img: string, idx: number) => (
                <img
                  key={idx}
                  src={img}
                  alt={`${product.name} ${idx + 2}`}
                  className="w-12 h-12 object-cover rounded"
                />
              ))}
            </div>
          )}
        </div>
      ) : (
        <div className="w-full h-48 bg-muted rounded-lg flex items-center justify-center mb-3">
          <Package className="h-12 w-12 text-muted-foreground" />
        </div>
      )}

      {/* Product Info */}
      <div className="space-y-2">
        <div>
          <h2 className="text-xl font-bold">{product.name || 'Product Name'}</h2>
          {product.brand && (
            <p className="text-xs text-muted-foreground">{product.brand}</p>
          )}
        </div>

        <div className="flex items-baseline gap-2">
          <span className="text-2xl font-bold">${product.price || '0.00'}</span>
          {product.compare_at_price && (
            <span className="text-base text-muted-foreground line-through">
              ${product.compare_at_price}
            </span>
          )}
        </div>

        {product.description && (
          <>
            {product.short_description && (
              <p className="text-sm font-medium">{product.short_description}</p>
            )}
            <p className="text-xs text-muted-foreground">{product.description}</p>
          </>
        )}

        {product.tags?.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {product.tags.map((tag: string) => (
              <span key={tag} className="px-2 py-1 bg-primary/10 text-primary text-xs rounded">
                {tag}
              </span>
            ))}
          </div>
        )}

        <div className="pt-3 border-t space-y-1 text-xs">
          {product.sku && (
            <div className="flex justify-between">
              <span className="text-muted-foreground">SKU:</span>
              <span className="font-medium">{product.sku}</span>
            </div>
          )}
          <div className="flex justify-between">
            <span className="text-muted-foreground">Stock:</span>
            <span className="font-medium">{product.stock || 0} units</span>
          </div>
          {product.is_featured && (
            <div className="flex items-center gap-2 text-primary">
              <span className="text-xs font-medium">⭐ Featured Product</span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
